import DynamicFeedIcon from '@mui/icons-material/DynamicFeed'
import { styled } from '@mui/material/styles'
import { ActiveHeaderIconButton } from './common'
import { colorPalette } from '../../../../style/colorPalette'

type PageConfigButtonProps = {
  isOpen: boolean
  onToggle: () => void
}

const StyledIcon = styled(DynamicFeedIcon)<{ isOpen: boolean }>(
  ({ theme, isOpen }) => ({
    color: isOpen ? colorPalette.monotone[0] : colorPalette.monotone[4],
    fontSize: '14px',
    transition: theme.transitions.create('color', {
      duration: theme.transitions.duration.short,
    }),
  })
)

export const PageConfigButton = ({
  isOpen,
  onToggle,
}: PageConfigButtonProps) => {
  return (
    <ActiveHeaderIconButton
      active={isOpen}
      onClick={onToggle}
      aria-label="ページ構成編集"
    >
      <StyledIcon isOpen={isOpen} />
    </ActiveHeaderIconButton>
  )
}
